<section class="tml" #frame (scroll)="scroll($event)" [class.loading]="isLoading" [class.is-empty]="!isLoading && curdata && curdata.length === 0">
  <div class="tml-corner-fill" [class.no-sidebar]="!sidebar">
    @if (sidebar) {
      @if (tabletype === TableType.Users) {
        <nb-toggle status="basic" [checked]="showcapacity" (checkedChange)="showcapacity = $event; updateSettings('timeline_cap', $event); refresh(false, null, false);">{{ 'showcapacity' | translate }}</nb-toggle>
      }
      <nb-toggle status="basic" [checked]="showtracked" (checkedChange)="showtracked = $event; updateSettings('timeline_tra', $event); refresh(false, null, false);">{{ 'showtracked' | translate }}</nb-toggle>
    }
  </div>
  <div #container class="tml-container">
    <div class="tml-header">
      <div #h0 class="tml-h0">

      </div>
      <div #h1 class="tml-h1">

      </div>
    </div>
    <div #side class="tml-side" [class.no-sidebar]="!sidebar" [nbSpinner]="!sidebar && isLoading">
      @for (d of curdata; track d) {
        <div class="tml-side-row" [style.height.px]="open && open.id === d.id ? openheight : null">
          <div>
            @if (fullEdit) {
              <div>
                <button nbButton [status]="open && open.id === d.id ? 'primary' : 'basic'" size="small" shape="round" (click)="openRow(d)"><nb-icon [icon]="open && open.id === d.id ? 'arrow-down' : 'arrow-right'"></nb-icon></button>
              </div>
            }
            @if (tabletype === TableType.Users && d.user && this.sidebar) {
              <nb-user
                shape="round"
                (click)="previewRow(d.id)" [name]="d.user?.name_first + ' ' + d.user?.name_last"
                [picture]="Globals.logo(d.user)" color="#eee" class="clickable"
              ></nb-user>
            }
            @if (tabletype === TableType.Clients && d.client && this.sidebar) {
              <nb-user
                shape="rectangle"
                (click)="previewRow(d.id)" [name]="d.client?.name"
              [picture]="Globals.logo(d.client)" color="#eee" class="clickable"></nb-user>
            }
            @if (tabletype === TableType.Projects && d.project && this.sidebar) {
              <nb-user
                shape="rectangle"
                (click)="previewRow(d.id)" [name]="d.project?.name"
                [picture]="Globals.logo(d.project)" [color]="d.project?.color" class="clickable"></nb-user>
            }
          </div>
        </div>
      }
    </div>
    <div #body class="tml-body">

    </div>
  </div>
  @if (!isLoading && curdata && curdata.length === 0) {
    <div class="tml-empty">
      <nb-icon icon="calendar-outline"></nb-icon>
      <span>{{ 'timelineempty' | translate }}</span>
    </div>
  }
</section>
